import { AddGiftCardModal } from 'components/gift-card-modal/add-gift-card';

export default function AddGiftCard() {
  return <AddGiftCardModal />;
}
